import { render, staticRenderFns } from "./LabelComponent.vue?vue&type=template&id=07690642&"
import script from "./LabelComponent.vue?vue&type=script&lang=js&"
export * from "./LabelComponent.vue?vue&type=script&lang=js&"
import style0 from "./LabelComponent.vue?vue&type=style&index=0&id=07690642&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports